import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { teamApi } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { AuthContext } from "@/lib/auth";

export default function AcceptInvitePage() {
  const nav = useNavigate();
  const loc = useLocation();
  const token = new URLSearchParams(loc.search).get("token") || "";
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [ready, setReady] = useState(false);
  useEffect(() => setReady(!!token), [token]);

  const submit = async () => {
    if (password !== confirm) return toast.error("Passwords do not match");
    if (password.length < 12) return toast.error("Password must be at least 12 characters");
    if (!name.trim()) return toast.error("Please enter your name");
    setSaving(true);
    try {
      const r = await teamApi.acceptInvite({ token, name: name.trim(), password });
      localStorage.setItem("alias_hq_token", r.data.access_token);
      localStorage.setItem("alias_hq_user", JSON.stringify(r.data.user));
      toast.success("Welcome to Alias HQ");
      window.location.href = "/";  // reload to boot auth context
    } catch (e) { toast.error(e.response?.data?.detail || "Failed to accept invite"); }
    finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0E17] flex items-center justify-center p-4">
      <div className="w-full max-w-md p-6 rounded-xl border border-white/10 bg-[#151A23]" data-testid="accept-invite-page">
        <div className="text-eyebrow mb-1">Alias Distribution HQ</div>
        <h1 className="text-2xl font-display font-semibold mb-4">Accept your invitation</h1>
        {!ready && <div className="text-white/60 text-sm">This link is missing a token. Ask the sender to resend the invitation.</div>}
        {ready && (
          <div className="space-y-3">
            <div><Label className="text-white/60 text-xs uppercase tracking-wider">Your name</Label><Input value={name} onChange={e=>setName(e.target.value)} className="mt-1.5 bg-white/5 border-white/10" data-testid="accept-name"/></div>
            <div><Label className="text-white/60 text-xs uppercase tracking-wider">Set a password (min 12 chars)</Label><Input type="password" value={password} onChange={e=>setPassword(e.target.value)} className="mt-1.5 bg-white/5 border-white/10" data-testid="accept-password"/></div>
            <div><Label className="text-white/60 text-xs uppercase tracking-wider">Confirm password</Label><Input type="password" value={confirm} onChange={e=>setConfirm(e.target.value)} className="mt-1.5 bg-white/5 border-white/10" data-testid="accept-confirm"/></div>
            <Button onClick={submit} disabled={saving} className="w-full rounded-full bg-white text-black hover:bg-white/90" data-testid="accept-submit">{saving ? "Creating…" : "Create account & continue"}</Button>
          </div>
        )}
      </div>
    </div>
  );
}
